import { Component } from '@angular/core';

@Component({
	selector: 'app-reservation-summary-combine',
	templateUrl: './reservation-summary-combine.component.html',
	styleUrls: ['./reservation-summary-combine.component.scss'],
})
export class ReservationSummaryCombineComponent {
	constructor() {}
}
